import React from 'react';
import { Box, Typography, TextField, Autocomplete } from '@mui/material';
import type { RoomType } from '../../../../../../services/ConfigurationService/types';

interface RoomInfoSectionProps {
  selectedRoom: RoomType | null;
  rooms: RoomType[];
  isDisabled: boolean;
  onRoomChange: (room: RoomType | null) => void;
}

export const RoomInfoSection: React.FC<RoomInfoSectionProps> = ({
  selectedRoom,
  rooms,
  isDisabled,
  onRoomChange
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Room Information
      </Typography>
      <Autocomplete
        options={rooms}
        getOptionLabel={(option) =>
          `${option.code}${option.description ? ` - ${option.description}` : ''}`
        }
        value={selectedRoom}
        onChange={(_, newValue) => onRoomChange(newValue)}
        disabled={isDisabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Room"
            size="small"
            placeholder="Select a room..."
            disabled={isDisabled}
            sx={{
              '& .MuiInputBase-input': {
                backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
              }
            }}
            helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
          />
        )}
      />
    </Box>
  );
};
